import crudSpectaculars from './crudSpectaculars.vue'
export default crudSpectaculars
